import Component from '@glimmer/component';
import { t } from 'ember-intl';
import TioFaqs from 'tio-common/components/tio/faqs';
import { Section } from 'tio-ui/components/layout';
import type { MatchPlanFaq } from 'tio-data/data/resources/match-plan.type';

type SyfFaqsSignature = {
  Args: {
    faqs: MatchPlanFaq[];
  };
};

class SyfFaqsComponent extends Component<SyfFaqsSignature> {
  get orderedFaqs(): Array<MatchPlanFaq> {
    return this.args.faqs.sort((a, b) => a.ordinal - b.ordinal);
  }

  <template>
    <Section>
      <:header>{{t "tuition_assistance.faq"}}</:header>
      <:body>
        {{#each this.orderedFaqs as |faq|}}
          <TioFaqs @question={{faq.heading}} @answer={{faq.body}} />
        {{/each}}
      </:body>
    </Section>
  </template>
}

export default SyfFaqsComponent;
